import { render, staticRenderFns } from "./gossip.vue?vue&type=template&id=4a8a80cd&scoped=true&"
import script from "./gossip.vue?vue&type=script&lang=js&"
export * from "./gossip.vue?vue&type=script&lang=js&"
import style0 from "./gossip.vue?vue&type=style&index=0&id=4a8a80cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a80cd",
  null
  
)

export default component.exports